import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Collapse, Paper, Stack, styled } from '@mui/material';

import { Button, Chip } from '@components/base';

import useRawDataRevision from '../hooks/useRawDataRevision';

import CompareRevisionsDialog from './CompareRevisionsDialog';

const ComparisonChip = styled(Chip)`
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  width: max-content;
`;

const CompareRevisions = () => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const { revisionsToCompare, toggleRevisionToCompare } = useRawDataRevision();

  const revisionIds = Array.from(revisionsToCompare.values());

  return (
    <Fragment>
      <Collapse in={revisionsToCompare.size > 0} orientation='horizontal'>
        <Stack component={Paper} direction='row' my={-0.25} p={1} spacing={1}>
          {revisionIds[0] && (
            <ComparisonChip
              icon='compareArrows'
              label={t('rawMetadata.revisionNo', { count: revisionIds[0].revisionNumber })}
              onDelete={() => toggleRevisionToCompare(revisionIds[0])}
            />
          )}

          {revisionIds[1] && (
            <ComparisonChip
              icon='compareArrows'
              label={t('rawMetadata.revisionNo', { count: revisionIds[1].revisionNumber })}
              onDelete={() => toggleRevisionToCompare(revisionIds[1])}
            />
          )}

          <Button disabled={revisionsToCompare.size < 2} onClick={() => setDialogOpen(true)}>
            {t('compare')}
          </Button>
        </Stack>
      </Collapse>

      {dialogOpen && <CompareRevisionsDialog onClose={() => setDialogOpen(false)} />}
    </Fragment>
  );
};

export default CompareRevisions;
